import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function ProfilePage() {
  const { user, updateUser } = useAuth();
  const [profile, setProfile] = useState({ name: user?.name || '', mobile: user?.mobile || '', address: user?.address || '' });
  const [pwForm,  setPwForm]  = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [saving,  setSaving]  = useState(false);
  const [pwSaving,setPwSaving]= useState(false);
  const [showPw,  setShowPw]  = useState(false);

  const handleProfile = e => setProfile(p => ({ ...p, [e.target.name]: e.target.value }));
  const handlePw      = e => setPwForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const saveProfile = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await api.put('/auth/profile', profile);
      updateUser(r.data.data);
      toast.success('Profile updated!');
    } catch (err) { toast.error(err.response?.data?.message || 'Update failed.'); }
    finally { setSaving(false); }
  };

  const savePassword = async e => {
    e.preventDefault();
    if (pwForm.newPassword !== pwForm.confirm) { toast.error('Passwords do not match.'); return; }
    if (pwForm.newPassword.length < 6) { toast.error('Min 6 characters.'); return; }
    setPwSaving(true);
    try {
      await api.put('/auth/change-password', { currentPassword: pwForm.currentPassword, newPassword: pwForm.newPassword });
      toast.success('Password changed!');
      setPwForm({ currentPassword: '', newPassword: '', confirm: '' });
    } catch (err) { toast.error(err.response?.data?.message || 'Failed.'); }
    finally { setPwSaving(false); }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20">
        <div className="bg-on-surface text-white px-6 md:px-10 py-10">
          <div className="max-w-screen-2xl mx-auto">
            <div className="flex items-center gap-2 font-label text-xs text-gray-500 uppercase tracking-widest mb-3">
              <Link to="/" className="hover:text-gray-300">Home</Link><span>/</span>
              <span className="text-gray-400">My Profile</span>
            </div>
            <h1 className="font-headline font-black text-4xl uppercase tracking-tight">My Profile</h1>
          </div>
        </div>

        <div className="max-w-screen-2xl mx-auto px-6 md:px-10 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

            {/* Profile info */}
            <div className="bg-white border border-outline-variant/20 p-8">
              <h2 className="font-headline font-black text-2xl uppercase tracking-tight mb-6">Personal Info</h2>
              <form onSubmit={saveProfile} className="space-y-5">
                <div>
                  <label className="input-label">Full Name</label>
                  <input name="name" value={profile.name} onChange={handleProfile} className="input-field" />
                </div>
                <div>
                  <label className="input-label">Email Address</label>
                  <input value={user?.email || ''} disabled className="input-field bg-surface-container cursor-not-allowed text-secondary" />
                  <p className="font-label text-[10px] text-secondary mt-1">Email cannot be changed.</p>
                </div>
                <div>
                  <label className="input-label">Mobile Number</label>
                  <input name="mobile" value={profile.mobile} onChange={handleProfile} className="input-field" />
                </div>
                <div>
                  <label className="input-label">Address</label>
                  <textarea name="address" value={profile.address} onChange={handleProfile} rows={3} className="input-field resize-none" />
                </div>
                <button type="submit" disabled={saving} className="btn-primary disabled:opacity-70">
                  {saving ? 'Saving...' : <><span className="material-symbols-outlined">save</span> Save Changes</>}
                </button>
              </form>
            </div>

            {/* Change password */}
            <div className="space-y-8">
              <div className="bg-white border border-outline-variant/20 p-8">
                <h2 className="font-headline font-black text-2xl uppercase tracking-tight mb-6">Change Password</h2>
                <form onSubmit={savePassword} className="space-y-5">
                  <div>
                    <label className="input-label">Current Password</label>
                    <div className="relative">
                      <input name="currentPassword" type={showPw ? 'text' : 'password'} value={pwForm.currentPassword}
                        onChange={handlePw} required className="input-field pr-10" placeholder="Current password" />
                      <button type="button" onClick={() => setShowPw(!showPw)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-secondary">
                        <span className="material-symbols-outlined text-[18px]">{showPw ? 'visibility_off' : 'visibility'}</span>
                      </button>
                    </div>
                  </div>
                  <div>
                    <label className="input-label">New Password</label>
                    <input name="newPassword" type="password" value={pwForm.newPassword} onChange={handlePw} required
                      className="input-field" placeholder="Min 6 characters" />
                  </div>
                  <div>
                    <label className="input-label">Confirm New Password</label>
                    <input name="confirm" type="password" value={pwForm.confirm} onChange={handlePw} required
                      className="input-field" placeholder="Repeat new password" />
                  </div>
                  <button type="submit" disabled={pwSaving} className="btn-primary disabled:opacity-70">
                    {pwSaving ? 'Updating...' : <><span className="material-symbols-outlined">lock_reset</span> Change Password</>}
                  </button>
                </form>
              </div>

              {/* Quick links */}
              <div className="bg-surface-container-low border border-outline-variant/20 p-6">
                <h3 className="font-headline font-bold text-lg uppercase tracking-tight mb-4">Quick Actions</h3>
                <div className="space-y-3">
                  <Link to="/products" className="flex items-center gap-3 text-sm text-on-surface hover:text-primary-container transition-colors font-label font-semibold">
                    <span className="material-symbols-outlined text-[20px] text-secondary">inventory_2</span>
                    Browse Products
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
